{
  "dataFieldsInTooltip": {
    "title": "Étiquette de survol de l'objet",
    "tooltip": "Choisissez jusqu'à 5 valeurs d'attribut à afficher lorsque vous passez la souris sur un objet cartographique.",
    "tooltipAttributeTypes": "Les types d'attributs pris en charge sont les suivants : Texte, Nombre, Liste et What3Words",
    "error": "Une erreur s'est produite, veuillez contacter le support si le problème persiste"
  },
  "tooltipShortcuts": {
    "select_object": "Appuyez sur V",
    "draw": "Appuyez sur D",
    "measure": "Appuyez sur M",
    "undo": "Ctrl + Z",
    "redo": "Ctrl + Maj + Z",
    "comment": "Appuyez sur C",
    "copy_paste": "Ctrl + C/Ctrl + V",
    "delete_object": "Appuyez sur Del",
    "cancel_drawing": "Appuyez sur Esc ou cliquez avec le bouton droit de la souris",
    "confirm_drawing": "Appuyez sur Entrée ou double-cliquez"
  },
  "draw": {
    "polygon": "Polygone",
    "line": "Ligne",
    "rectangle": "Rectangulaire",
    "routePlanner": "Planificateur d'itinéraires",
    "point": "Point",
    "model": "modèle",
    "icon": "Icône"
  },
  "select": {
    "select_object": "Sélectionnez un objet",
    "select_area": "Sélectionnez des objets dans la zone"
  },
  "drawRoute": "Tracer l'itinéraire",
  "drawLineRectangle": "Tracer une ligne rectangulaire",
  "layerOptionsTooltips": {
    "lock_layer": "Couche de verrouillage",
    "unlock_layer": "Déverrouiller la couche",
    "cannot_lock_layer_while_editing": "Vous ne pouvez pas verrouiller une couche pendant que vous la modifiez"
  },
  "sitemapVersion": {
    "perimeter": "Périmètre",
    "drawOutsideCADPerimeter": "Impossible de dessiner en dehors des limites à ce niveau"
  },
  "map_objects": "objets cartographiques",
  "map_object": "objet cartographique",
  "plan": "plan",
  "map_layer": "couches cartographiques",
  "layers": "couches",
  "layer": "couche",
  "layer_data_field": "champ de données de couche",
  "layer_geoJson": "couche au format GeoJSON",
  "route_waypoints": "points de cheminement",
  "map_objects_attribute_values": "valeurs des attributs des objets cartographiques",
  "saved_map_view": "vue cartographique enregistrée",
  "map_object_geometry": "géométrie des objets cartographiques",
  "map_background": "fond de carte",
  "map_sidebar_order": "ordre de la barre latérale de la carte",
  "map_comment": "commentaire sur la carte",
  "model": "modèle",
  "snapping": {
    "snapToDraw": "Fixer à un objet"
  },
  "drawMapObjectTooltip": "Cliquez pour ajouter un autre objet à cette couche",
  "exports2": {
    "title": "Titre",
    "imageUpload": {
      "title": "Logo personnalisé"
    }
  },
  "digitalTwin": {
    "occupiedTable": {
      "id": "ID du serveur",
      "status": "État",
      "user": "Utilisateur"
    },
    "status": {
      "Occupied": "En cours d'utilisation",
      "Available": "Disponible",
      "Starting": "Commençant",
      "Stopped": "Arrêté",
      "Error": "Erreur"
    },
    "occupiedPopup": {
      "header": "Tous les serveurs jumeaux numériques sont actuellement indisponibles",
      "message": "Veuillez réessayer ultérieurement, ou contactez {{ supportEmail }} pour plus d'informations"
    }
  },
  "fileUpload": {
    "invalid_compression_size": "Le fichier que vous essayez de télécharger est trop volumineux et n'a pas pu être compressé."
  }
}